<template>
  <div>
    <div
      class="card p-3"
      @click="show = true">
      <div class="card__hd py-1 px-2 rounded-top">
        <img
          src="@/assets/medical.png"
          alt=""
          width="52"
          height="52"
          class="medical-icon">
        {{ data.hospital_flag }}
      </div>
      <div
        class="d-flex align-items-center  p-3 rounded-bottom card__bd justify-content-between">
        <div class="d-flex">
          <picture class="avatar">
            <source
              srcset="@/assets/user-avatar.webp"
              type="image/webp">
            <source
              srcset="@/assets/user-avatar.png"
              type="image/png">
            <img
              src="@/assets/user-avatar.png"
              alt="头像"
              width="78"
              height="112"
              class="avatar">
          </picture>
          <div class="pl-3 pt-2">
            <p class="m-0">姓名：{{ data.name }}</p>
            <p class="m-0">卡号：{{ data.medical_card_id }}</p>
          </div>
        </div>
        <div>
          <img
            src="@/assets/switch-man.png"
            alt="头像"
            width="20"
            height="20"
          >
        </div>
      </div>
    </div>
<!--    <div
      v-else
      class="card p-3">
      <div class="card__hd py-1 px-2 rounded-top">
        <img
          src="@/assets/medical.png"
          alt=""
          width="52"
          height="52"
          class="medical-icon">
        添加就诊卡
      </div>
      <div
        class="d-flex flex-column align-items-center p-3 rounded-bottom card__bd">
        <picture class="d-block mb-2 no-card">
          <source
            srcset="@/assets/no-card.webp"
            type="image/webp">
          <source
            srcset="@/assets/no-card.png"
            type="image/png">
          <img
            src="@/assets/no-card.png"
            alt=""
            width="120"
            height="120"
            class="no-card">
        </picture>
        <van-button
          type="warning"
          size="small"
          class="px-3"
          @click="$router.push({name: 'card'})">
          添加就诊卡
        </van-button>
      </div>
    </div>-->
    <van-popup
      v-model="show"
      position="bottom">
      <van-picker
        ref="cardPicker"
        :columns="columns"
        show-toolbar
        @confirm="handleOnConfirm"
        @cancel="handleOnCancel" />
    </van-popup>
  </div>
</template>

<script>
import bus from '@/libs/bus';
import currentCardService from '@/libs/currentCard';

export default {
  name: 'CardInfo',
  data() {
    return {
      hasCard: true,
      data: {
        hospital_flag: '',
        name: '',
        medical_card_id: '',
      },
      show: true,
      columns: [],
      medicalCardMap: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.handleLoad();
    });
  },
  activated() {
    this.handleLoad();
  },
  methods: {
    async handleLoad() {
      // 获取picker里面的值
      const patientName = this.$refs.cardPicker.getColumnValue(0);
      // picker需要先显示后才能通过ref引用, 先true后false
      this.show = false;
      
      const cardList = await currentCardService.listCards({hospital_id_list: '6,8'});
      
      const map = new Map();
      const list = [];
      cardList.forEach((item) => {
        map.set(item.name, item);
        list.push(`${item.name}`);
      });
      this.medicalCardMap = map;
      this.columns = list;
      // 如果picker有选择过则显示之前卡的信息,否则显示第一个
      const [data] = cardList;
      this.data = data;
      if (patientName) {
        const name = cardList.find((value) => {
          const result = value.name === patientName;
          return result;
        });
        if (name) {
          this.data = name;
        }
      }
      if (this.data) {
        bus.$emit('load-card', true, {
          hospital_id: this.data.hospital_id,
          medical_card_id: this.data.medical_card_id,
        });
        this.hasCard = true;
        bus.$emit('change', this.data);
      } else {
        bus.$emit('load-card', false);
        this.$toast.fail('没有就诊卡信息');
      }
    },
    handleOnConfirm(value) {
      const card = this.medicalCardMap.get(value);
      this.data = card;
      this.show = false;
      bus.$emit('change', card);
    },
    handleOnCancel() {
      this.show = false;
    },
  },
};
</script>

<style scoped>
.card__hd {
  background: url('../assets/panel-hd.png') #168ff5 no-repeat scroll center/cover;
  color: #fff;
}

.card__bd {
  background-color: #fff;
}

.avatar {
  width: 39px;
  height: 56px;
}

.medical-icon {
  width: 16px;
  height: 16px;
}
.no-card {
  width: 80px;
  height: 80px;
}
.switch-man {
  justify-content: right;
}
</style>
